// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/chunk-" + {"644":"cda07b23b294551c","725":"89650c9b8d2fc083"}[chunkId] + ".css";
};